// Premium Transam Carriers - Professional Mock Data

export const companyInfo = {
  name: "Lepus Group Inc",
  tagline: "Transportation Excellence",
  subtitle:
    "Premium Team Service, proudly delivering across Canada and the United States",
  description:
    "A full-service LTL, Truckload, and logistics provider with a strong focus on premium Team Service, delivering across Canada and the United States since 2006",
  phone: "1-800-80-LEPUS",
  phoneRaw: "18008053787", // Raw number for tel: links
  email: "lepus@lepusgroup.ca",
  emergencyLine: "1-800-80-LEPUS",
  emergencyLineRaw: "18008053787",
  address: "182 Lingham St, Belleville ON K8N 3T4, Canada",
  establishedYear: "2006",
  hours: "Monday - Friday 08:00 - 18:00",
};

export const heroImages = {
  primary:
    "https://images.unsplash.com/photo-1577075473292-5f62dfae5522?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHx0cnVja3xlbnwwfHx8Ymx1ZXwxNzUzMjM3NjY0fDA&ixlib=rb-4.1.0&q=85",
  secondary:
    "https://images.unsplash.com/photo-1585541571714-01aa54eaf7c2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHx0cnVja3xlbnwwfHx8Ymx1ZXwxNzUzMjM3NjY0fDA&ixlib=rb-4.1.0&q=85",
  logistics:
    "https://images.unsplash.com/photo-1587149185211-28a2ef4c9a10?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxsb2dpc3RpY3N8ZW58MHx8fGJsdWV8MTc1MzIzNzY3MHww&ixlib=rb-4.1.0&q=85",
  team: "https://images.unsplash.com/photo-1602750766769-8db8d49cc369?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHx0cnVja3xlbnwwfHx8Ymx1ZXwxNzUzMjM3NjY0fDA&ixlib=rb-4.1.0&q=85",
  fleet:
    "https://images.unsplash.com/photo-1566449781267-88f21cc4af19?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxsb2dpc3RpY3N8ZW58MHx8fGJsdWV8MTc1MzIzNzY3MHww&ixlib=rb-4.1.0&q=85",
  // New truck images for enhanced pages
  truck1:
    "https://images.unsplash.com/photo-1485575301924-6891ef935dcd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHx0cnVja3xlbnwwfHx8fDE3NTMyNDIxMzh8MA&ixlib=rb-4.1.0&q=85",
  truck2:
    "https://images.unsplash.com/photo-1592838064575-70ed626d3a0e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHx0cnVja3xlbnwwfHx8fDE3NTMyNDIxMzh8MA&ixlib=rb-4.1.0&q=85",
  truck3:
    "https://images.unsplash.com/photo-1501700493788-fa1a4fc9fe62?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHx0cnVja3xlbnwwfHx8fDE3NTMyNDIxMzh8MA&ixlib=rb-4.1.0&q=85",
  transportation1:
    "https://images.unsplash.com/photo-1498084393753-b411b2d26b34?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHx0cmFuc3BvcnRhdGlvbnxlbnwwfHx8fDE3NTMyNDIxNDV8MA&ixlib=rb-4.1.0&q=85",
  transportation2:
    "https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHx0cmFuc3BvcnRhdGlvbnxlbnwwfHx8fDE3NTMyNDIxNDV8MA&ixlib=rb-4.1.0&q=85",
  transportation3:
    "https://images.unsplash.com/photo-1578575437130-527eed3abbec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHx0cmFuc3BvcnRhdGlvbnxlbnwwfHx8fDE3NTMyNDIxNDV8MA&ixlib=rb-4.1.0&q=85",
  warehouse:
    "https://images.unsplash.com/photo-1565793298595-6a879b1d9492?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxsb2dpc3RpY3N8ZW58MHx8fHwxNzUzMjQyMTYxfDA&ixlib=rb-4.1.0&q=85",
  logistics2:
    "https://images.unsplash.com/photo-1504376830547-506dedfe1fe9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxsb2dpc3RpY3N8ZW58MHx8fHwxNzUzMjQyMTYxfDA&ixlib=rb-4.1.0&q=85",
};

export const statistics = [
  {
    id: 1,
    number: 98.5,
    display: "98.5%",
    label: "On-Time Service Rate",
    icon: "Clock",
    suffix: "%",
    precision: 1,
  },
  {
    id: 2,
    number: 18,
    display: "18+",
    label: "Years of Experience",
    icon: "Award",
    suffix: "+",
  },
  {
    id: 3,
    number: 24,
    display: "24/7",
    label: "Customer Support",
    icon: "Headphones",
    suffix: "/7",
  },
  {
    id: 4,
    number: 2,
    display: "2 Countries",
    label: "Service Coverage",
    icon: "Globe",
    suffix: " Countries",
  },
  {
    id: 5,
    number: 100,
    display: "100%",
    label: "Committed to Excellence",
    icon: "Shield",
    suffix: "%",
  },
  {
    id: 6,
    number: 1000,
    display: "1000+",
    label: "Satisfied Clients",
    icon: "Users",
    suffix: "+",
  },
];

export const partners = [
  {
    id: 1,
    name: "Packaging Solutions Inc.",
    description: "Leading packaging manufacturer serving North America",
    logo: "/api/placeholder/160/80",
    partnership_duration: "8+ years",
    category: "Packaging",
    loads_per_year: "2,400+",
  },
  {
    id: 2,
    name: "Retail Distribution Corp.",
    description: "Major retail goods distributor across Canada and USA",
    logo: "/api/placeholder/160/80",
    partnership_duration: "6+ years",
    category: "Retail Goods",
    loads_per_year: "3,200+",
  },
  {
    id: 3,
    name: "Automotive Parts Ltd.",
    description: "Automotive parts manufacturer and distributor",
    logo: "/api/placeholder/160/80",
    partnership_duration: "5+ years",
    category: "Automotive",
    loads_per_year: "1,800+",
  },
  {
    id: 4,
    name: "Small Parcel Solutions",
    description: "Consolidation services for small parcel shipments",
    logo: "/api/placeholder/160/80",
    partnership_duration: "4+ years",
    category: "Small Parcel",
    loads_per_year: "4,100+",
  },
];

export const services = [
  {
    id: 1,
    title: "Full Truckload Service",
    shortDescription:
      "Ready to put your full truckload (FTL) on the road as soon as possible, short haul or long haul. Our highly trained drivers ensure your freight is delivered fast and safe.",
    fullDescription:
      "Lepus Group is always ready to put your full truckload (FTL) on the road as soon as possible, short haul or long haul. Our highly trained drivers will make sure your freight is delivered fast and safe with our premium team service.",
    icon: "Truck",
    features: [
      "Professional team drivers",
      "Short haul and long haul capabilities",
      "Fast and safe delivery",
      "Real-time tracking",
      "Competitive pricing",
      "Dedicated customer support",
    ],
    benefits: [
      "Faster transit times",
      "Enhanced cargo security",
      "Reduced handling damage",
      "Flexible scheduling",
      "Cost-effective solutions",
    ],
    industries: ["Manufacturing", "Retail", "Automotive", "Food & Beverage"],
  },
  {
    id: 2,
    title: "LTL Service",
    shortDescription:
      "If you have less than a truckload (LTL) of freight – just one skid or a dozen – you can always trust Lepus Group with delivering it quickly and reliably at a price that is just right.",
    fullDescription:
      "Our LTL services provide cost-effective solutions for smaller freight shipments. Whether it's one skid or a dozen, we deliver quickly and reliably at competitive prices.",
    icon: "Package",
    features: [
      "One skid to multiple pallets",
      "Competitive pricing",
      "Quick and reliable delivery",
      "Flexible scheduling",
      "Professional handling",
      "Real-time tracking",
    ],
    benefits: [
      "Cost-effective shipping",
      "Reliable delivery windows",
      "Professional handling",
      "Flexible shipment sizes",
      "Competitive rates",
    ],
    industries: ["E-commerce", "Small Business", "Manufacturing", "Retail"],
  },
  {
    id: 3,
    title: "Intermodal Service",
    shortDescription:
      "Take advantage of multiple modes of transportation. Lepus Group has a rail offering from Ontario to Western Canada for truckload shipments that are deferred in nature.",
    fullDescription:
      "For cost-effective transportation, our intermodal services combine rail and truck transport from Ontario to Western Canada, perfect for deferred truckload shipments.",
    icon: "Globe",
    features: [
      "Rail and truck combination",
      "Ontario to Western Canada",
      "Cost-effective solution",
      "Deferred shipments",
      "Environmental benefits",
      "Reliable scheduling",
    ],
    benefits: [
      "Reduced transportation costs",
      "Environmentally friendly",
      "Reliable scheduling",
      "Large capacity handling",
      "Long-distance efficiency",
    ],
    industries: ["Manufacturing", "Retail", "Construction", "Agriculture"],
  },
  {
    id: 4,
    title: "Team Service",
    shortDescription:
      "With our experienced and well-matched team drivers, expertly trained in the latest safety standards, your freight moves nonstop, arriving faster, safer, and exactly where it needs to be.",
    fullDescription:
      "Our Team Service features experienced and well-matched team drivers, expertly trained in the latest safety standards, ensuring your freight moves nonstop for faster, safer deliveries.",
    icon: "Users",
    features: [
      "Experienced team drivers",
      "Latest safety training",
      "Nonstop freight movement",
      "Faster delivery times",
      "Enhanced safety measures",
      "Professional coordination",
    ],
    benefits: [
      "Faster transit times",
      "Continuous movement",
      "Enhanced safety",
      "Professional service",
      "Reliable delivery",
    ],
    industries: ["Healthcare", "Manufacturing", "Automotive", "Technology"],
  },
  {
    id: 5,
    title: "Cross-Docking",
    shortDescription:
      "With Lepus Group's strategically located cross-dock facility in Belleville Ontario, we provide additional value-added services including cross-docking of freight.",
    fullDescription:
      "Our cross-dock facility in Belleville Ontario provides comprehensive cross-docking services for efficient freight transfer and distribution.",
    icon: "Warehouse",
    features: [
      "Strategic facility location",
      "Strategic location in Belleville",
      "Efficient freight transfer",
      "Value-added services",
      "Professional handling",
      "Flexible scheduling",
    ],
    benefits: [
      "Reduced handling time",
      "Cost-effective distribution",
      "Strategic location",
      "Professional service",
      "Flexible operations",
    ],
    industries: ["Retail", "E-commerce", "Manufacturing", "Distribution"],
  },
  {
    id: 6,
    title: "Consolidation Services",
    shortDescription:
      "Lepus Group has significant experience in the consolidation and deconsolidation of shipments both domestically and cross border with our unique combined truckload and LTL services.",
    fullDescription:
      "Our consolidation services combine multiple shipments for efficient transportation, offering both domestic and cross-border consolidation and deconsolidation services.",
    icon: "Zap",
    features: [
      "Domestic and cross-border",
      "Consolidation and deconsolidation",
      "Combined TL and LTL",
      "Experienced handling",
      "Cost optimization",
      "Flexible solutions",
    ],
    benefits: [
      "Reduced shipping costs",
      "Efficient routing",
      "Flexible solutions",
      "Professional handling",
      "Cross-border expertise",
    ],
    industries: ["Import/Export", "Manufacturing", "Retail", "E-commerce"],
  },
];

export const aboutContent = {
  vision:
    "To provide quality, cost effective and professional transportation services to our customers safely and reliably, establishing ourselves as the carrier of choice for leading Canadian and American businesses.",
  mission:
    "Lepus Group Inc. was established in 2006 in response to an overwhelming need for a reliable and price-competitive transport company serving North America. With a mission and vision that both owners and employees support, Lepus Group has a clear and definitive path.",
  values: [
    {
      title: "Reliable Delivery",
      description:
        "We offer LTL and FTL deliveries throughout Canada and into the Mid-Western and Eastern USA. We always know what's happening to your freight thanks to satellite tracking and state-of-the-art logistics systems.",
      icon: "Shield",
    },
    {
      title: "Flexible Options",
      description:
        "We have the expertise and resources to ensure your freight is delivered just in time – with a single driver or a team. Our flexible approach benefits both clients and drivers.",
      icon: "Zap",
    },
    {
      title: "Tailored Service",
      description:
        "Catering for diverse business requirements, we offer consolidation, freight forwarding, intermodal shipping and more to provide tailored solutions that regularly exceed expectations.",
      icon: "Heart",
    },
    {
      title: "24/7 Support",
      description:
        "With advanced telematics, GPS tracking and electronic dispatch, we ensure your freight stays on the move 24/7, with skilled operators always available to inform you about delivery status.",
      icon: "Headphones",
    },
  ],
  story:
    "Founded in 2006, Lepus Group Inc. has quickly established itself as the carrier of choice for many leading Canadian and American businesses. Growing from one truck to our current size, Lepus Group's growth is the result of customer satisfaction and our unwavering commitment to providing the very best in transportation services. As a privately held company with an engaged workforce, we have grown over the years focusing on providing excellent transportation and logistics solutions. With a commitment to on-time and damage-free delivery, we are committed to Transportation Excellence.",
  milestones: [
    {
      year: "2006",
      event: "Company founded with vision for reliable transport",
      achievement: "Established in Belleville, Ontario",
    },
    {
      year: "2008",
      event: "Expanded fleet and service area",
      achievement: "Serving Ontario and Midwest USA",
    },
    {
      year: "2010",
      event: "Added cross-border capabilities",
      achievement: "Full Canada-USA service",
    },
    {
      year: "2012",
      event: "Introduced team service",
      achievement: "Premium team driver program",
    },
    {
      year: "2015",
      event: "Launched intermodal services",
      achievement: "Rail and truck integration",
    },
    {
      year: "2018",
      event: "Opened consolidation facility",
      achievement: "Enhanced consolidation services",
    },
    {
      year: "2020",
      event: "Digital transformation and technology upgrade",
      achievement: "Advanced tracking systems",
    },
    {
      year: "2024",
      event: "Celebrating 18 years of Transportation Excellence",
      achievement: "Industry-leading service",
    },
  ],
};

export const contactInfo = {
  headquarters: {
    title: "Head Office",
    address: "182 Lingham St",
    city: "Belleville ON K8N 3T4, Canada",
    phone: companyInfo.phone,
    phoneRaw: companyInfo.phoneRaw,
    email: companyInfo.email,
    hours: "Monday - Friday: 08:00 - 18:00",
  },
  operations: {
    title: "24/7 Operations & Dispatch",
    address: "182 Lingham St",
    city: "Belleville ON K8N 3T4, Canada",
    phone: "1-800-80-LEPUS ext. 1",
    phoneRaw: "18008053787",
    email: "dispatch@lepusgroup.ca",
    hours: "24/7 Dispatch & Customer Support",
  },
  newOrders: {
    title: "New Orders Booking",
    phone: "1-800-80-LEPUS ext. 8020",
    phoneRaw: "18008053787",
    email: "orders@lepusgroup.ca",
    description: "Quick quote requests and new order booking",
  },
  safety: {
    title: "Safety Department",
    phone: "1-800-80-LEPUS ext. 8008",
    phoneRaw: "18008053787",
    email: "safety@lepusgroup.ca",
    contact: "Safety Manager",
    description: "Safety inquiries and compliance matters",
  },
  careers: {
    title: "Careers & HR",
    phone: "1-800-80-LEPUS ext. 5",
    phoneRaw: "18008053787",
    email: "careers@lepusgroup.ca",
    contact: "HR Manager",
    description: "Driver recruitment and employment opportunities",
  },
};

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    title: "Logistics Manager",
    company: "Packaging Solutions Inc.",
    content:
      "Lepus Group has been our trusted partner for over 8 years. Their team service and commitment to on-time delivery has helped us maintain our competitive edge. The professional drivers and real-time tracking give us complete confidence in every shipment.",
    rating: 5,
    shipments: "2,400+ annual loads",
    partnership: "8 years",
  },
  {
    id: 2,
    name: "Michael Chen",
    title: "Supply Chain Director",
    company: "Retail Distribution Corp.",
    content:
      "Working with Lepus Group feels like having an extension of our own logistics team. Their expertise in both LTL and FTL services, combined with their cross-border capabilities, has been crucial for our North American operations. Outstanding reliability and service.",
    rating: 5,
    shipments: "3,200+ annual loads",
    partnership: "6 years",
  },
  {
    id: 3,
    name: "Jennifer Martinez",
    title: "Operations Manager",
    company: "Automotive Parts Ltd.",
    content:
      "The team at Lepus Group understands the complexities of automotive logistics. Their flexible scheduling and team service approach ensures our parts are delivered exactly when needed. They've helped us improve our supply chain efficiency significantly.",
    rating: 5,
    shipments: "1,800+ annual loads",
    partnership: "5 years",
  },
  {
    id: 4,
    name: "David Wilson",
    title: "Transportation Coordinator",
    company: "Small Parcel Solutions",
    content:
      "Lepus Group's consolidation services have been invaluable for our operations. Their experience in handling small parcel consolidations and their strategic location in Belleville makes them our preferred partner. Professional service and competitive pricing.",
    rating: 5,
    shipments: "4,100+ annual loads",
    partnership: "4 years",
  },
];

export const awards = [
  {
    id: 1,
    title: "Carrier of the Year",
    organization: "Canadian Trucking Alliance",
    year: "2024",
    category: "Safety Excellence",
  },
  {
    id: 2,
    title: "Top 100 For-Hire Carriers",
    organization: "Transport Topics",
    year: "2023",
    category: "Growth & Innovation",
  },
  {
    id: 3,
    title: "Best Logistics Provider",
    organization: "Supply Chain Canada",
    year: "2023",
    category: "Customer Service",
  },
  {
    id: 4,
    title: "Safety Award",
    organization: "American Trucking Associations",
    year: "2024",
    category: "Accident Prevention",
  },
];

export const navigationItems = [
  { name: "Home", path: "/" },
  { name: "Services", path: "/services" },
  { name: "About", path: "/about" },
  { name: "Coverage", path: "/coverage" },
  { name: "Contact", path: "/contact" },
];
